import React, { Component } from 'react';

class Loading extends Component {
	render() {
		return (
			<>
				<div
					id="loading"
					style={{
						position: 'fixed',
						width: '100%',
						height: '100%',
						backgroundColor: '#FFF',
					}}
				>
					<h1>Loading...</h1>
				</div>
			</>
		);
	}
}

export default Loading;
